<template>
    <div class="invoice">
        <Header :companyName="companyName" :logo="logo"></Header>

        <Properties
                :clientName="clientName"
                :invoiceNum="invoiceNum"
                :sellerName="sellerName"
                :dateCustom="dateCustom"
                :address="address"
                :addressIs="addressIs"
                :dateIs="dateIs"
                :clientNameIs="clientNameIs"
                :invoiceNumIs="invoiceNumIs"
                :sellerNameIs="sellerNameIs"
                :propsLeftCustom="propsLeftCustom"
                :propsRightCustom="propsRightCustom"

        ></Properties>

        <Products :value="products"></Products>

        <Report :totalPrice="this.totalPrice" :priceWithTax="this.priceWithTax" :messages="messages"></Report>
    </div>
</template>

<script>
    import Header from "./Header"
    import Properties from "./Properties"
    import Products from "./Products"
    import Report from "./Report"

    export default ({
        data: () => ({
            "priceWithTax" : 0,
            "totalPrice" : 0,
        }),
        props: {
            companyName: {},
            clientName: {},
            invoiceNum: {},
            sellerName: {},
            dateCustom:{},
            address: {},
            addressIs: {Boolean},
            dateIs: {Boolean},
            clientNameIs: {Boolean},
            invoiceNumIs: {Boolean},
            sellerNameIs: {Boolean},
            products: {},
            logo:{},
            messages:{},
            totalPriceP:{},
            priceWithTaxP:{},
            propsLeftCustom:{},
            propsRightCustom:{}

        },
        methods: {
            calculatingTotalPrice() {

                this.products.forEach((item) => {
                    this.totalPrice += (item.price * item.quantity)
                })
            },
            calculatingPriceWithTax() {

                this.products.forEach((item) => {
                    this.priceWithTax += ((item.price + item.discount) * item.quantity)
                })
            }
        },
        components: {
            Header,
            Properties,
            Products,
            Report
        },
        mounted() {
            console.log(this.totalPriceP)
            if (this.totalPriceP == "default" || this.totalPriceP == undefined || this.totalPriceP == "" )
                this.calculatingTotalPrice();
            else this.totalPrice = this.totalPriceP

            if (this.priceWithTaxP == "default" || this.priceWithTaxP == undefined || this.priceWithTaxP == "" )
                this.calculatingPriceWithTax()
            else this.priceWithTax = this.priceWithTaxP
        }
    })
</script>


<style scoped>
    .invoice{
        width: 40%;
        display: block;
        margin: 30px auto;
        background-color: rgb(230, 225, 225);
        padding: 60px 80px;
        box-shadow: -20px 80px 50px #66271d80, -30px 90px 20px #66271d70;
        padding-bottom: 200px;
    }
</style>
